import { NotificationDetailMobilePage } from '@/pages/mobile/shared/NotificationDetailMobilePage';

export function LeaderNotificationDetailMobilePage() {
  return <NotificationDetailMobilePage variant="leader" />;
}
